import { Box } from '@ff-it/ui';
import { ReactElement, ReactNode } from 'react';
import cx from 'clsx';
import { cell as s } from './style.css';
import { amountCell, balanceCell, controlCell, linkCell, periodCell, stackedRow, textCell } from '../style.css';

type RowContainerProps = {
  className?: string;
  cell?: 'td' | 'th';
  rowLink?: ReactNode;
  supplier?: ReactNode;
  period?: ReactNode;
  invoiceable?: ReactNode;
  invoiced?: ReactNode;
  balance?: ReactNode;
  control?: ReactNode;
  invoicedLabel?: string;
};

export function RowContainer({
  className,
  cell = 'td',
  rowLink,
  supplier,
  period,
  invoiceable,
  invoiced,
  balance,
  control,
  invoicedLabel = 'Invoiced',
}: RowContainerProps): ReactElement {
  const hasPeriod = period != null;

  return (
    <Box as="tr" className={cx(stackedRow, className)}>
      <Box as={cell} className={linkCell} textAlign="center">
        {rowLink}
      </Box>
      <Box as={cell} className={cx(s, textCell)} colSpan={hasPeriod ? undefined : 2}>
        {supplier}
      </Box>
      {hasPeriod && (
        <Box as={cell} className={cx(s, periodCell)} textAlign="center">
          {period}
        </Box>
      )}
      <Box as={cell} className={cx(s, amountCell)} textAlign="right" data-label="Invoiceable">
        {invoiceable}
      </Box>
      <Box as={cell} className={cx(s, amountCell)} textAlign="right" data-label={invoicedLabel}>
        {invoiced}
      </Box>
      <Box as={cell} className={cx(s, amountCell, balanceCell)} textAlign="right" data-label="Balance">
        {balance}
      </Box>
      <Box as={cell} className={controlCell} textAlign="center">
        {control}
      </Box>
    </Box>
  );
}
